// Mode segmented control plus Dynamic from/to date inputs.
// The FY / Dynamic kind toggle is owned by FilterBar's DateRangeToggle —
// rendering it here too produced a duplicate "DATE RANGE" segment on Row 1.

import { useCallback, type ChangeEvent } from "react";
import type { DashboardMode } from "../types";
import { useFilterStore } from "../state/filterStore";

export function ModeToggles(): JSX.Element {
  const mode = useFilterStore((s) => s.mode);
  const dateRange = useFilterStore((s) => s.dateRange);
  const setMode = useFilterStore((s) => s.setMode);
  const setDateRange = useFilterStore((s) => s.setDateRange);

  const onPickMode = useCallback(
    (m: DashboardMode) => {
      if (m !== mode) setMode(m);
    },
    [mode, setMode],
  );

  const onChangeFrom = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setDateRange({
        ...dateRange,
        kind: "dynamic",
        from: e.target.value || undefined,
      });
    },
    [dateRange, setDateRange],
  );

  const onChangeTo = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setDateRange({
        ...dateRange,
        kind: "dynamic",
        to: e.target.value || undefined,
      });
    },
    [dateRange, setDateRange],
  );

  return (
    <>
      <div className="dash-filter-field">
        <span className="dash-filter-field__header">Mode</span>
        <div className="dash-segmented" role="group" aria-label="Mode">
          <button
            type="button"
            className={`dash-segmented__pill${
              mode === "quotes" ? " dash-segmented__pill--active" : ""
            }`}
            onClick={() => onPickMode("quotes")}
            aria-pressed={mode === "quotes"}
            title="Highlights quote columns (Issued / Quoted) — doesn't filter rows"
          >
            Quotes
          </button>
          <button
            type="button"
            className={`dash-segmented__pill${
              mode === "orders" ? " dash-segmented__pill--active" : ""
            }`}
            onClick={() => onPickMode("orders")}
            aria-pressed={mode === "orders"}
            title="Highlights order columns (Won / Sold / Released) — doesn't filter rows"
          >
            Orders
          </button>
        </div>
      </div>

      {dateRange.kind === "dynamic" ? (
        <>
          <div className="dash-filter-field">
            <span className="dash-filter-field__header">From</span>
            <input
              type="date"
              className="dash-control dash-filter-field__date"
              value={dateRange.from ?? ""}
              onChange={onChangeFrom}
              aria-label="Date range from"
              title="Start of a custom window (blank = no lower bound)"
            />
          </div>
          <div className="dash-filter-field">
            <span className="dash-filter-field__header">To</span>
            <input
              type="date"
              className="dash-control dash-filter-field__date"
              value={dateRange.to ?? ""}
              onChange={onChangeTo}
              aria-label="Date range to"
              title="End of a custom window (blank = no upper bound)"
            />
          </div>
        </>
      ) : null}
    </>
  );
}
